import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenContent", "button"]

  show(event) {
    if (event) event.preventDefault()

    this.hiddenContentTargets.forEach(el => {
      el.classList.remove("hidden")
      el.classList.add("animate-fade-in")
    })

    if (this.hasButtonTarget) {
      this.buttonTarget.classList.add("hidden")
    }
  }
}
